import React, { useState } from "react";
import { Button, Stack, TextField, Tooltip } from "@mui/material";
import { set } from "lodash";
import { errorJsonHasErrors } from "./Input_Fns";
import { InputCheck } from "./Input_Check";

export const InputName = ({
  label = "Name",
  name = "Name",
  value,
  required = true,
  maxLength = 19,
  width = 200,
  onChange,
  tooltip = "",
  onError = null,
  accountName = false,
  ...others
}) => {
  const [errors, setErrors] = useState({})

  const onBlur = (e) => {
    let ne = structuredClone(errors)
    let err = ""

    if (e.target.name === name) {
      if (required && value === "") {
        err = "Please enter a " + label
      } else if (accountName === true && value.slice(-1) === "*") {
        err = "Account Name cannot end with '*'"
      }

      ne = set(ne, e.target.name, err)
      setErrors(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }
      //console.log(ne)
      //console.log(name)
      //console.log(ne[name])

    }
  }
  return (
    <Tooltip title={tooltip} arrow>
      <TextField
        label={label}
        name={name}
        type="text"

        required={required}
        slotProps={{
          htmlInput: { maxLength: maxLength },
        }}
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        size="small"
        sx={{ width: { width } }}
        value={value}
        onChange={onChange}
        error={!!errors[name]}
        helperText={errors[name]}
        onBlur={onBlur}
        {...others}
      />
    </Tooltip>
  );
};

export const Input_label = ({
  label = "Label",
  name = "label",
  required = true,
  maxLength = 63,
  ...others
}) => {


  return (
    <InputName
      label={label}
      name={name}
      required={required}
      maxLength={maxLength}

      {...others}
    />
  );
};


export const Input_Comment = ({
  label = "Comment",
  name = "Comment",
  minwidth = 1000,
  maxwidth = 1000,
  minlines = 1,
  maxlines = 3,
  comment,
  onChange,
  ...others
}) => {
  const [focus, setFocus] = useState(false);

  return (

    <TextField
      label={label}
      name={name}
      style={{ width: focus ? 1000 : 1000 }}

      type="text"
      multiline
      size="small"
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      rows={focus ? maxlines : minlines}
      value={comment}
      onChange={onChange}
      {...others}
    />
  );
};

export const Input_Comment_Def = ({
  defC,
  comment,
  defComment,
  onChange,
  button = null,
  ...others
}) => {

  return (
    <>
    </>
    /*
    <Stack direction="row" spacing={2}>
      <InputCheck
        label="Default Comment"
        name="DefaultComment"
        onChange={(n, v) => onChange(v, comment)}
        value={defC}
      />
      <Input_Comment
        comment={defC ? defComment : comment}
        onChange={(e) => onChange(defC, e.target.value)}
        disabled={defC}
      />
      {button &&
        <Button
          variant="contained"
        >
          {button}



        </Button>
      }

    </Stack>
    */
  )
};




